import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import {
  getCompany,
  listPlaceOfSupply,
  listUserCompanies,
} from "../../graphql";
import { PURGE } from "redux-persist";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";
export const fetchPosList = createAsyncThunk("posList", async () => {
  const res = await API.graphql(graphqlOperation(listPlaceOfSupply));
  console.log("response", res);
  if (res?.data) return res?.data;
});

const INITIAL_STATE = {
  posList: [],
  render: true,
  Loaded: false,
  loading: false,
};
const PosList = createSlice({
  name: "pos",
  initialState: INITIAL_STATE,
  reducers: {
    setPOSList(state, action) {
      state.posList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPosList.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchPosList.fulfilled, (state, action) => {
        if (action?.payload) {
          return {
            ...state,
            posList: action.payload,
            Loaded: true,
          };
        } else {
          state.Loaded = true;
        }
      })
      .addCase(fetchPosList.rejected, (state) => {
        state.Loaded = false;
        showErrorSnackbar("Network Error !");
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { setPOSList } = PosList.actions;
export default PosList.reducer;
